import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {PopoverInfo} from 'shells/popover-info/popover-info';

import {IntegerStat, FormattedIntegerStat, PercentStat, DateStat, DurationStat} from './stats';

import styles from './list-summary-stat.module.css';

export const statComponents = {
    integer: IntegerStat,
    formattedInteger: FormattedIntegerStat,
    percent: PercentStat,
    date: DateStat,
    duration: DurationStat,
} as const;

export type Summary = {
    label: string;
    key: string;
    getDataFromStat: (stat: any) => any | null | undefined;
    type: keyof typeof statComponents;
    precision?: number;
    info?: string;
};

type ListSummaryStatProps = {
    isLoading: boolean;
    isDisabled: boolean;
    data?: any;
    summary: Summary;
    isUnderlined?: boolean;
};

export class ListSummaryStat extends React.Component<ListSummaryStatProps> {
    render() {
        const {data, summary, isDisabled, isLoading} = this.props;
        const StatComponent = statComponents[summary.type];
        const value = data ? summary.getDataFromStat(data) : null;

        return isDisabled ? (
            <div className={styles.container} />
        ) : (
            <div
                className={
                    this.props.isUnderlined ? styles['container-underlined'] : styles.container
                }
            >
                <div className={styles.value}>
                    {isLoading || value === null ? (
                        <div className={styles['loading-lines-container']}>
                            <LoadingIcon size={18} />
                        </div>
                    ) : (
                        value && <StatComponent value={value} precision={summary.precision} />
                    )}
                </div>
                <div className='flex'>
                    <div className={styles.label}>{summary.label}</div>
                    {summary.info && <PopoverInfo info={summary.info} />}
                </div>
            </div>
        );
    }
}
